import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';


export const getData = async ({page = 1, pageSize = 10 }) => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getCareerGuidanceAndInternship?page=${page}&page_size${pageSize}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const addData = async ({ title, url}) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addCareerGuidanceAndInternship`,
            { title, url},
          );
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const editData = async ({ id, title, url}) => {
    try {
        const response = await ApiClient.put(`/researchandstudentlife/updateCareerGuidanceAndInternship/${id}`,
            { title, url},
            
               
            );
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteData = async ({ id }) => {
    try {
        ApiClient.delete()
        const response = await ApiClient.delete(`/researchandstudentlife/deleteCareerGuidanceAndInternship/${id}`)
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}